import { createContext } from "react";
import { IGoogleAnaliticsContext } from "./models/IGoogleAnaliticsContext";

export const GoogleAnaliticsContext = createContext<IGoogleAnaliticsContext>({});